import React from "react";
import { Container } from "reactstrap";
import Typesix from "./Typesix";
export default function Swipetype() {
  return (
    <div>
      <Container fluid>
        {/* <h3> 1 </h3>formik
        
        <Progress color="danger" value="100" />
        <h3>2</h3> no onblur
        <Typetwo />
        <Progress color="danger" value="100" /> */}
        {/* <h3> </h3> own handlechange
        <Typethree />
        <Progress color="danger" value="100" /> */}
        {/* <h3>4</h3> oninput
        <Typefour />
        <Progress color="danger" value="100" />
        <h3>5</h3> oninputcapture
        <Typefive />
        <Progress color="danger" value="100" /> */}
        <Typesix />
      </Container>
    </div>
  );
}
